<a href="#main-content" class="skip-link">Skip to main content</a>
@if (showHeader()) {
  <app-header />
  <main id="main-content" class="main-content">
    <router-outlet />
  </main>
  <app-footer />
} @else {
  <main id="main-content">
    <router-outlet />
  </main>
}
